// Every ambient effect the board draws, by name, and which a theme wears.
// Slow drift is the one that moves the picture itself, so it is a style on the
// backdrop rather than a canvas over it (Backdrop.tsx).

import { effectFromParticles } from "../../../shared/effects";
import type { EffectKind, ThemeEffect } from "../../../shared/types";
import type { ThemeDef } from "../themes";
import { bubbles, embers, fireflies, leaves, mist, motes, petals, rain, snow } from "./air";
import type { Effect } from "./kit";
import { glints, glow, sunbeams } from "./light";
import { aurora, clouds, lightning, meteors, stars } from "./sky";

export type { Effect, EffectEnv } from "./kit";
export { mapPicture, type PictureMap } from "./map";

export const DRAWN: Record<Exclude<EffectKind, "drift">, Effect> = {
  aurora,
  stars,
  meteors,
  lightning,
  clouds,
  mist,
  rain,
  snow,
  fireflies,
  motes,
  embers,
  petals,
  leaves,
  bubbles,
  sunbeams,
  glow,
  glints,
};

/**
 * The effects a theme wears: its own, or, for a theme made before effects
 * existed, the falling things its scene asked for, over its picture. A drawn
 * scene draws its own particles, so it gets nothing extra.
 */
export function effectsOf(def: ThemeDef, showsPicture: boolean): ThemeEffect[] {
  const own = def.custom?.effects;
  if (own) return own;
  if (!showsPicture) return [];
  const old = effectFromParticles(def.scene?.particles);
  return old ? [old] : [];
}
